import * as RoutePaths from '../constants/RoutePaths';

export const getPropertyPathname = id => `${RoutePaths.PROPERTY}/${id}`;

export const getObjectEditPathname = id => `${RoutePaths.PROPERTY}/${id}/edit`;



// WEBPACK FOOTER //
// ./src/utils/Route.js